export const DEFAULT_SESSION_ID = "00000000-0000-0000-0000-000000000000";
